import styles from './LegalPage.module.css';

const StatesPage = () => {
  const states = [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado',
    'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho',
    'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana',
    'Maine', 'Maryland', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri',
    'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico',
    'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon',
    'Pennsylvania', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas',
    'Utah', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
  ];

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1>States We Serve</h1>

        <section>
          <p>
            Oval Care provides telemedicine services across the United States through its partnership with WebDoctors' licensed physician network.
          </p>
          <p className={styles.lastUpdated}>Last Updated: December 18, 2025</p>
        </section>

        <section>
          <h2>Overview</h2>
          <p>
            Oval Care facilitates access to telemedicine consultations in 47 U.S. states. All clinical evaluations and prescribing decisions are performed by licensed physicians from WebDoctors, a LegitScript-certified telemedicine provider. Our role is to provide the technology platform that enables patient intake, communication tools, and workflow routing. All medical services are delivered exclusively by WebDoctors' clinicians, who ensure compliance with state-specific telemedicine regulations.
          </p>
        </section>

        <section>
          <h2>Compliance With State Requirements</h2>
          <p>
            Telemedicine regulations vary by state. To ensure full compliance:
          </p>
          <ul>
            <li>WebDoctors' physicians determine the required communication method for each consultation—questionnaire, synchronous audio, or synchronous video—based on the patient's state of residence.</li>
            <li>In states requiring synchronous audio, physicians conduct a real-time audio call before prescribing.</li>
            <li>In states requiring synchronous video, physicians conduct a live video consultation as required by law.</li>
            <li>No prescriptions are issued without meeting the minimum state-specific telehealth interaction requirements.</li>
          </ul>
          <p>
            Oval Care continually reviews compliance standards with WebDoctors to ensure that all consultations adhere to the laws of each jurisdiction.
          </p>
        </section>

        <section>
          <h2>List of States We Serve</h2>
          <p>Oval Care serves patients in the following states:</p>
          <div className={styles.stateGrid}>
            {states.map((state, index) => (
              <div key={index} className={styles.stateItem}>
                {state}
              </div>
            ))}
          </div>
          <p className={styles.note}>
            <strong>Oval Care does not currently provide services in Massachusetts, Rhode Island, or Vermont.</strong>
          </p>
        </section>

        <section>
          <h2>Clinical Provider Disclosure</h2>
          <p>
            All medical consultations, diagnoses, treatment decisions, and prescriptions are provided by:
          </p>
          <p className={styles.highlight}>
            <strong>WebDoctors</strong><br />
            A LegitScript-certified telemedicine provider<br />
            Licensed physicians covering the states in which services are offered
          </p>
          <p>
            Oval Care does not provide medical services or clinical decision-making. Oval Care provides the digital platform used by patients and physicians.
          </p>
        </section>

        <section>
          <h2>Technology Platform Disclosure</h2>
          <p>
            Telemedicine consultations on Oval Care's website are conducted via:
          </p>
          <p className={styles.highlight}>
            <strong>DrCare247</strong> – Our telehealth technology partner providing software-only functionality for communication tools (questionnaires, audio, video). DrCare247 does not participate in clinical decision-making nor issue prescriptions.
          </p>
        </section>

        <section>
          <h2>State-Specific Disclosure Requirements</h2>
          <p>
            Some states require telemedicine providers to publicly display provider licensure information. Oval Care will publish applicable provider details in jurisdictions where this disclosure is required when services are offered in those jurisdictions and credentialing verification is complete.
          </p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            If you have any questions, please contact us at:
          </p>
          <address>
            Oval Care, Inc.<br />
            Attn: Patient Care Team<br />
            848 Brickell Avenue PH5,<br />
            Miami, FL 33131<br />
            United States<br />
            Phone: +1 (737) 396-1791<br />
            Email: <a href="mailto:support@ovalcare.com">support@ovalcare.com</a>
          </address>
        </section>
      </div>
    </div>
  );
};

export default StatesPage;
